import { Icon } from 'gu-ui-kit'
import React from 'react'

//const now = new Date()
//const startDate = subWeeks(now, 2)

export default () => ({
  initial: {
    query: '',
    statuses: [],
    // date_from: format(startDate, 'yyyy-MM-dd'),
    // date_to: format(now, 'yyyy-MM-dd'),
    date_from: null,
    date_to: null,
  },
  configuration: {
    statuses: {
      subbutton: {
        isVisible: (value = [], breakpoints) =>
          value.length > 0 || !!breakpoints.fb,
      },
      icon: (
        <Icon
          name={'checkmark2'}
          size={'s'}
          bgColor={'secondary-34'}
          color={'basic-primary-white'}
        />
      ),
      label: 'referral::payouts_invoices.filters.dropdown.items.statuses.label',
      position: 'dropdown',
      type: 'checkbox group',
      // Помимо типа фильтра добавляем имя типа для компонента, который отображается на большом разрешении в фильтр панели
      // (когда фильтр является самостоятельной кнопкой, а не выпадает из поисковой строки например)
      typeAsButtonControl: 'checkbox selector',
      optionLabelPrefix:
        'referral::payouts_invoices.filters.dropdown.items.statuses.options.',
      options: [
        'new',
        'pending',
        'declined',
        'handled',
        'blocked',
        'cancelled',
      ],
    },
    query: {
      subbutton: { isVisible: (value = '') => !!value },
      label: 'referral::payouts_invoices.filters.input.placeholder',
      placeholder: 'referral::payouts_invoices.filters.input.placeholder',
      order: 1,
      type: 'input',
    },
    datepicker: {
      names: ['date_from', 'date_to'],
      subbutton: {
        // eslint-disable-next-line no-unused-vars
        isVisible: (value = [], breakpoints) => !!breakpoints.sm,
      },
      // @todo нужен общий лейбл а не в пульсе
      label: 'pulse::filters.range.label',
      order: 2,
      type: 'datepicker',
    },
  },
})
